<div class="modal-header container-md" id="modal-header">
  <div class="col-4"></div>
  <div class="col-4">
    <img
      id="modal-memorabid-logo"
      src="/assets/img/memorabid-logo-white.svg"
      alt="MEMORABID"
    />
  </div>
  <div class="col-3"></div>
  <div class="col-1">
    <button
      id="closeButton"
      type="button"
      class="close"
      aria-label="Close"
      (click)="activeModal.dismiss()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</div>
<div class="modal-body mx-3">
  <div>
    <h4 class="text-uppercase">{{ "IDS_BIDS_HISTORY" | translate }}</h4>
  </div>
  <div>
    <label class="offers"
      >{{ totalBids() }} {{ "IDS_BIDS" | translate }} |
      {{ totalBidder() }} {{ "IDS_BIDDERS" | translate }}</label
    >
  </div>
  <div class="my-3 table-responsive-sm table-wrapper">
    <table class="table">
      <thead class="table-active text-uppercase">
        <tr>
          <th>{{ "IDS_BID" | translate }}</th>
          <th>{{ "IDS_USER" | translate }}</th>
          <th>{{ "IDS_DATE" | translate }}</th>
          <th>{{ "IDS_TIME" | translate }}</th>
          @if(authService.userLogged?.idProfile == 1){
          <th></th>
          }
        </tr>
      </thead>
      @for (offer of auctionBidHistoryList(); track offer){
      <tbody>
        <tr>
          <td>{{ offer.offeredPrice }} €</td>
          <td>
            @if(offer.countryIso){
            <i class="flag:{{ offer.countryIso }}" ></i>
            }
            {{ offer.username }}
          </td>
          <td>{{ offer.offeredDate + "Z" | date : "dd/MM/yyyy" }}</td>
          <td>{{ offer.offeredDate + "Z" | date : "HH:mm:ss" }}</td>
          @if(authService.userLogged?.idProfile == 1){
          <td>
            <button
              class="admin-edit-delete-button me-2"
              (click)="deleteOffer(offer.idBid)"
            >
              <fa-icon [icon]="faTrash"></fa-icon>
            </button>
          </td>
          }
        </tr>
      </tbody>
      }
    </table>
  </div>
</div>
